<template>
    <div class="col-xxl-6 col-xl-6 mb-3">
         <h5 class="title-section">Top 5 Termination/Withdrawn Reasons</h5>
         <div
           class="overallInfo-blockWrapper noHeight dashboard-card p-3 pb-2"
         >
           <div class="table-responsive">
             <table class="table">
               <thead>
                 <tr>
                   <th>Reasons</th>
                   <th>Total Members</th>
                   <th>(in %)</th>
                 </tr>
               </thead>
               <tbody>
                <template v-if="!sortedList.length">
                  <tr>
                    <td colspan="3" class="text-center">No records found</td>
                  </tr>
                </template>
                <template v-else>
                 <tr v-for="item in sortedList" :key="item.act">
                   <td>{{getReasonName(item.act)}}</td>
                   <td class="text-center">{{item.total}}</td>
                   <td>{{item.percentage}}%</td>
                 </tr>
                </template>
               </tbody>
             </table>
           </div>
         </div>
       </div>
  </template>

<script>
import {termedWithdrawnOptions} from "@/utils/constant";
export default {
    data(){
        return{
            termedWithdrawnOptions
        }
    },
    props:{
        sortedList:Array
    },
    methods:{
        getReasonName(act){
            return this.termedWithdrawnOptions.find(item=>item.value===act).text
        }
    }
}
</script>
